// https://developer.mozilla.org/en-US/docs/Web/API/Selection

export interface SelectionPoint {
  node: Node;
  textOffset: number;
  afterNode?: Node;
}

export interface SelectionLookup {
  anchor?: SelectionPoint;
  focus?: SelectionPoint;
}

function selectionPointsAreEqual(a: SelectionPoint, b: SelectionPoint): boolean
{
  return (a && b) && a.node === b.node && a.textOffset === b.textOffset;
}

function makeSelectionPoint(node: Node, offset: number): SelectionPoint
{
  if (node.nodeName === '#text') {
    return {
      node: node,
      textOffset: offset,
    };
  } else {
    return (
      offset >= node.childNodes.length
        ? {
          node: undefined,
          textOffset: 0,
          afterNode: node.childNodes[offset - 1],
        }
        : {
          node: node.childNodes[offset],
          textOffset: 0,
        }
    );
  }
}

export function makeSelectionLookup(): SelectionLookup
{
  const selection = window.getSelection();
  const range = selection.rangeCount > 0 ? selection.getRangeAt(0) : undefined;

  const anchor = range &&
    makeSelectionPoint(range.startContainer, range.startOffset);

  const focus = range &&
    makeSelectionPoint(range.endContainer, range.endOffset);

  return {
    anchor: anchor,
    focus: selectionPointsAreEqual(anchor, focus) ? undefined : focus,
  };
}



// WEBPACK FOOTER //
// ./src/app/text/text.view.div.selection.ts